import { emptyV2Api as api } from "../../../emptyV2Api";
import { PlanUploadJobItem } from "./planUploadJobItem";
import { ProductPlanItem } from "./productPlanItem";

export const addTagTypes = ["ProductPlan"] as const;
const SLUG = "/usim/product-plans"
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getProductPlans: build.query<ProductPlanItem[], void>({
        query: () => ({
          url: SLUG + "/manage",
          method: "GET",
        }),
        providesTags: ["ProductPlan"],
      }),
      getSingleProductPlan: build.query<ProductPlanItem, string>({
        query: (productPlan) => ({
          url: SLUG + "/manage?plan=" + productPlan,
          method: "GET",
        }),
        providesTags: ["ProductPlan"],
      }),
      getProductPlanUploadJobs: build.query<PlanUploadJobItem[], void>({
        query: () => SLUG + "/upload",
        providesTags: ["ProductPlan"],
      }),
      postProductPlan: build.mutation<ProductPlanItem, ProductPlanItem>({
        query: (productPlan) => ({
          url: SLUG + "/manage",
          method: "POST",
          body: productPlan,
        }),
        invalidatesTags: ["ProductPlan"],
      }),
      putProductPlan: build.mutation<ProductPlanItem, ProductPlanItem>({
        query: (productPlan) => ({
          url: SLUG + "/manage",
          method: "PUT",
          body: productPlan,
        }),
        invalidatesTags: ["ProductPlan"],
      }),
      deleteProductPlan: build.mutation<ProductPlanItem, ProductPlanItem>({
        query: (productPlan) => ({
          url: SLUG + "/manage?plan=" + productPlan.Id,
          method: "DELETE",
        }),
        invalidatesTags: ["ProductPlan"],
      }),
    }),
  });

export const {
  useGetProductPlansQuery,
  useGetSingleProductPlanQuery,
  usePostProductPlanMutation,
  usePutProductPlanMutation,
  useDeleteProductPlanMutation,
  useGetProductPlanUploadJobsQuery,
} = injectedRtkApi;
